import { CurrencyPipe, NgClass, NgOptimizedImage, ViewportScroller } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NgxTolgeeModule } from '@tolgee/ngx';

import { GiftCartItem, GiftFormat } from '../../../../core/model/cart/cart-item.model';
import { ProductType } from '../../../../core/model/product.model';
import { CartItemLineComponent } from '../checkout/cart-item-line/cart-item-line.component';
import { emulateClick } from '../core/a11y';
import { GiftFormComponent } from '../gift-form/gift-form.component';
import { HoverGradientDirective } from '../shared/directives/hover-gradient.directive';
import { Product } from '../shared/model/product.model';
import { CartService } from '../shared/services/cart.service';
import { ProductService } from '../shared/services/product.service';
import { SiteService } from '../shared/services/site.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-gift-certificate',
  imports: [
    HoverGradientDirective,
    NgOptimizedImage,
    NgxTolgeeModule,
    RouterLink,
    ReactiveFormsModule,
    NgClass,
    GiftFormComponent,
    CartItemLineComponent,
    CurrencyPipe
  ],
  templateUrl: './gift-certificate.component.html'
})
export class GiftCertificateComponent {
  readonly emulateClick = emulateClick;
  readonly GiftFormat = GiftFormat;
  viewportScroller = inject(ViewportScroller);
  siteService = inject(SiteService);
  productService = inject(ProductService);
  cartService = inject(CartService);
  new = true;
  gifts = computed(() => this.cartService.cart().items
    .filter(i => {
      const product = this.productService.get(i.product) as Product;
      return product.type === ProductType.GiftCertificate;
    }) as GiftCartItem[]);
  total = computed(() => this.gifts()
    .reduce((total, gift) =>
      total +
      this.siteService.price(gift.product).price +
      (gift.format === GiftFormat.mail ? this.siteService.price(this.productService.managementFee().id).price : 0), 0));
  taxes = computed(() => (this.total() * 10 / 12).toFixed(2));

  product = new FormControl('', { nonNullable: true, validators: [Validators.required] });
  gift = new GiftCartItem();

  constructor() {
    this.product.valueChanges.subscribe(product => this.gift.product = product);
  }

  giftFormSubmitted = async (gift: GiftCartItem): Promise<void> => {
    if (!this.product) {
      return;
    }
    if (!this.new) {
      await this.cartService.update(this.gift, new GiftCartItem({ ...gift, product: this.product.value }));
    } else {
      await this.cartService.add([{ cartItem: new GiftCartItem({ ...gift, product: this.product.value }) }]);
    }
    this.gift = new GiftCartItem();
    this.product.setValue('');
    this.new = true;
    this.viewportScroller.scrollToAnchor('anchor');
  }


  async edit(item: GiftCartItem): Promise<void> {
    this.new = false
    this.gift = item
    this.product.setValue(item.product);
    this.viewportScroller.scrollToAnchor('formStart');
  }
}
